// 获取历史记录
import {httpGet, httpPost, httpPut} from "@/utils/http";

export const getUserSession = () => {
    return httpGet(`/api/user/session`);
};
// 登录
export const postUserLogin = (data) => {
    return httpPost(`/api/user/login`, data?.value || data);
};
// 注册
export const postUserRegister = (data) => {
    return httpPost(`/api/user/register`, data?.value || data);
};
// 找回密码
export const postUserFindPwd = (data) => {
    return httpPost(`/api/user/findPwd`, data?.value || data);
}
// 退出
export const postUserLogout = () => {
    return httpPost(`/api/user/logout`);
}
// 用户总分
export const getUserCalls = () => {
    return httpGet(`/api/user/calls`);
}
// 更新用户信息
export const updateUserProfile = (data) => {
    return httpPut(`/api/user/profile`, data?.value || data);
}
// 用户信息
export const getUserProfile = () => {
    return httpGet(`/api/user/profile`);
}
// 兑换码
export const postUserRedeemCodeUse = (data) => {
    return httpPost(`/api/user/redeemCode/use`, data?.value || data);
}
// 用户积分详情
export const getUserPoints = (params) => {
    const queryString = new URLSearchParams(params).toString();
    return httpGet(`/api/user/points?${queryString}`);
};
// postUserBindMobile 用户绑定手机号
export const postUserBindMobile = (data) => {
    return httpPost(`/api/user/bind/mobile`, data?.value || data);
}
// 更改用户密码
export const postUserPassword = (data) => {
    return httpPost(`/api/user/password`, data?.value || data);
}